(() => {
  if (window.atlasOverlayManagerLoaded) return;
  window.atlasOverlayManagerLoaded = true;

  const launcherSelectors = [
    '[id$="__5394799768760407377"] .rq-whatsapp-chat-container',
    '[id$="__8837987693456358955"] .reputon-reviews-holder.reputon-small',
    'envolve-vsa',
  ];
  const bodyStateClasses = [
    'drawer-open',
    'header-mini-cart-open',
    'mobile-menu-open',
    'page-layout-sidebar-drawer-open',
    'pickup-availability-drawer-open',
    'quick-view-drawer-open',
  ];
  let personaliserOpener = null;
  let personaliserWasOpen = false;
  let scheduled = false;
  let validationFieldIndex = 0;
  const envolveStyleId = 'atlas-envolve-visibility';

  const getPilotConfig = () => {
    const source = document.querySelector('script[id^="AtlasPersonaliserPilot-"]');
    if (!source) return null;
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return null;
    }
  };

  const getValidationConfig = () => {
    const pilotConfig = getPilotConfig();
    return {
      requiredError: window.atlasPersonaliserStrings?.requiredError || pilotConfig?.requiredError || '',
      requiredUploadError: window.atlasPersonaliserStrings?.requiredUploadError || pilotConfig?.requiredError || '',
      validationSummary: window.atlasPersonaliserStrings?.validationSummary || pilotConfig?.requiredError || '',
    };
  };

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const getPersonaliser = () => {
    const overlay = document.querySelector('.pplr_crop-modal');
    const dialog = overlay?.querySelector('.pplr-popup, .pplr-modal-box');
    return isVisible(overlay) && isVisible(dialog || overlay) ? overlay : null;
  };

  const isUnmanagedDialogOpen = (dialog) => {
    const productModal = dialog.closest('product-modal');
    if (productModal) return productModal.hasAttribute('open') && isVisible(dialog);
    const searchModal = dialog.closest('header-search-dropdown-modal');
    if (searchModal) return searchModal.getAttribute('open') === 'true' && isVisible(dialog);
    if (dialog.closest('drawer-modal')) return false;
    return isVisible(dialog);
  };

  const getActiveDialog = () => {
    const personaliser = getPersonaliser();
    if (personaliser) return personaliser.querySelector('.pplr-popup, .pplr-modal-box') || personaliser;
    const known = document.querySelector(
      'product-modal[open] [role="dialog"], header-search-dropdown-modal[open="true"] [role="dialog"], body.header-mini-cart-open #HeaderMiniCart, body.drawer-open drawer-modal[aria-modal="true"]',
    );
    if (isVisible(known)) return known;
    return [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].find(isVisible) || null;
  };

  const preparePersonaliser = (overlay) => {
    const dialog = overlay.querySelector('.pplr-popup, .pplr-modal-box') || overlay;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Create your stamp');
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    const close = overlay.querySelector('.js-modal-close.pplr_close, .pplr_close');
    if (close) {
      close.setAttribute('aria-label', 'Close personaliser');
      if (!close.hasAttribute('href') && close.tagName !== 'BUTTON') {
        close.setAttribute('role', 'button');
        close.setAttribute('tabindex', '0');
      }
    }
    return dialog;
  };

  const createPilotSection = (className, heading, text) => {
    const section = document.createElement('section');
    section.className = `atlas-personaliser-pilot__section ${className}`;
    const title = document.createElement('h2');
    title.className = 'atlas-personaliser-pilot__heading';
    title.textContent = heading;
    const copy = document.createElement('p');
    copy.className = 'atlas-personaliser-pilot__copy';
    copy.textContent = text;
    section.append(title, copy);
    return section;
  };

  const makeClickKeyboardOperable = (element) => {
    if (element.dataset.atlasKeyboardOperable === 'true') return;
    element.dataset.atlasKeyboardOperable = 'true';
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      element.click();
    });
  };

  const updatePilotChoiceStates = (dialog) => {
    dialog.querySelectorAll('.pplr-drop-item').forEach((choice) => {
      choice.setAttribute('role', 'radio');
      choice.setAttribute('aria-checked', choice.classList.contains('active') ? 'true' : 'false');
      choice.tabIndex = choice.classList.contains('active') ? 0 : -1;
      makeClickKeyboardOperable(choice);
    });
    dialog.querySelectorAll('.pplr-swatch-element').forEach((choice) => {
      const name = choice.dataset.name || choice.textContent.trim();
      choice.setAttribute('role', 'radio');
      choice.setAttribute('aria-label', name);
      choice.setAttribute('aria-checked', choice.classList.contains('selected') ? 'true' : 'false');
      choice.tabIndex = choice.classList.contains('selected') ? 0 : -1;
      makeClickKeyboardOperable(choice);
    });
    dialog.querySelectorAll('.pplr-selecter-selected').forEach((choice) => {
      const options = choice.parentElement?.querySelector('.pplr-selecter-options');
      const label = choice.parentElement?.querySelector('.pplrlabel')?.textContent.trim();
      choice.setAttribute('role', 'button');
      choice.setAttribute('aria-haspopup', 'listbox');
      choice.setAttribute('aria-expanded', isVisible(options) ? 'true' : 'false');
      if (label) choice.setAttribute('aria-label', `${label}: ${choice.textContent.trim()}`);
      choice.tabIndex = 0;
      makeClickKeyboardOperable(choice);
      options?.setAttribute('role', 'listbox');
      options?.querySelectorAll('.pplr-selecter-item').forEach((option) => {
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', option.classList.contains('selected-font') ? 'true' : 'false');
        option.tabIndex = 0;
        makeClickKeyboardOperable(option);
      });
    });
  };

  const formatAcceptedFiles = (accept) => {
    const formats = [];
    const add = (format) => {
      if (!formats.includes(format)) formats.push(format);
    };
    if (/jpe?g/i.test(accept)) add('JPG');
    if (/png/i.test(accept)) add('PNG');
    if (/webp/i.test(accept)) add('WebP');
    if (/heic/i.test(accept)) add('HEIC');
    if (/svg/i.test(accept)) add('SVG');
    return formats.join(', ');
  };

  const enhancePilotPersonaliser = (dialog) => {
    const config = getPilotConfig();
    if (!config) return;
    dialog.classList.add('atlas-personaliser-pilot');

    const form = dialog.querySelector('.pplr_form');
    const controls = form?.querySelector('.pplr-p-right') || form;
    if (!form || !controls) return;

    const wrappers = [...controls.querySelectorAll('.pplr-wrapper')];
    wrappers.forEach((wrapper, index) => {
      const label = wrapper.querySelector(':scope > .pplrlabel');
      const control = wrapper.querySelector(':scope > input:not([type="hidden"]), :scope > textarea, :scope > select, .pplrfileuploadbutton input[type="file"]');
      if (label && !label.id) label.id = `AtlasZeptoLabel-${index + 1}`;
      if (control && label) {
        if (!control.id) control.id = `AtlasZeptoField-${index + 1}`;
        label.htmlFor = control.id;
        if (control.required || control.classList.contains('cstmfy_c_required')) {
          control.setAttribute('aria-required', 'true');
          if (!label.querySelector('.atlas-personaliser-pilot__requirement')) {
            const requirement = document.createElement('span');
            requirement.className = 'atlas-personaliser-pilot__requirement';
            requirement.textContent = config.requiredText;
            label.append(requirement);
          }
        }
      }
      const choiceGroup = wrapper.querySelector('.pplrgcolor, .pplr-drop-item') ? wrapper : null;
      if (choiceGroup && label) {
        wrapper.setAttribute('role', 'radiogroup');
        wrapper.setAttribute('aria-labelledby', label.id);
      }
    });

    const firstWrapper = wrappers[0];
    if (firstWrapper && !controls.querySelector('.atlas-personaliser-pilot__section--content')) {
      firstWrapper.before(createPilotSection('atlas-personaliser-pilot__section--content', config.contentHeading, config.contentText));
    }
    const firstStyle = controls.querySelector('.pplr-font-select, .pplr-color-select');
    if (firstStyle && !controls.querySelector('.atlas-personaliser-pilot__section--style')) {
      firstStyle.before(createPilotSection('atlas-personaliser-pilot__section--style', config.styleHeading, config.styleText));
    }
    const addButton = form.querySelector('.p_a_t_c');
    const existingReviews = [...form.querySelectorAll('.atlas-personaliser-pilot__section--review')];
    existingReviews.slice(1).forEach((section) => section.remove());
    if (addButton && existingReviews.length === 0) {
      const review = createPilotSection('atlas-personaliser-pilot__section--review', config.reviewHeading, config.reviewText);
      const advisory = document.createElement('p');
      advisory.className = 'atlas-personaliser-pilot__advisory';
      advisory.textContent = config.advisory;
      review.append(advisory);
      addButton.before(review);
    }

    const preview = form.querySelector('.pplr-p-left');
    const previewCanvas = preview?.querySelector('#pplr_canvas, canvas');
    if (preview && previewCanvas && !preview.querySelector('.atlas-personaliser-pilot__preview-copy')) {
      const copy = document.createElement('div');
      copy.className = 'atlas-personaliser-pilot__preview-copy';
      const heading = document.createElement('h2');
      heading.id = 'AtlasPersonaliserPreviewHeading';
      heading.className = 'atlas-personaliser-pilot__heading';
      heading.textContent = config.previewHeading;
      const note = document.createElement('p');
      note.className = 'atlas-personaliser-pilot__copy';
      note.textContent = config.impression ? `${config.impression}. ${config.previewNote}` : config.previewNote;
      copy.append(heading, note);
      preview.prepend(copy);
      previewCanvas.setAttribute('role', 'img');
      previewCanvas.setAttribute('aria-labelledby', heading.id);
    }

    const upload = controls.querySelector('input[type="file"]');
    const uploadWrapper = upload?.closest('.pplr-wrapper');
    if (upload && uploadWrapper && !uploadWrapper.querySelector('.atlas-personaliser-pilot__field-help')) {
      const help = document.createElement('p');
      help.id = 'AtlasPersonaliserUploadHelp';
      help.className = 'atlas-personaliser-pilot__field-help';
      const formats = formatAcceptedFiles(upload.getAttribute('accept') || '');
      help.textContent = [config.uploadLead, formats ? `${config.acceptedFiles}: ${formats}.` : '', config.uploadLimits].filter(Boolean).join(' ');
      uploadWrapper.querySelector('.pplrlabel')?.after(help);
      upload.setAttribute('aria-describedby', help.id);
    }

    controls.querySelectorAll('.pplrjscolor').forEach((input) => {
      input.setAttribute('aria-hidden', 'true');
      input.tabIndex = -1;
    });

    const wording = controls.querySelector('textarea[name="properties[Add your text]"]');
    const wordingWrapper = wording?.closest('.pplr-wrapper');
    if (wording && wordingWrapper && config.wordingGuidance) {
      let help = wordingWrapper.querySelector('.atlas-personaliser-pilot__field-help');
      if (!help) {
        help = document.createElement('p');
        help.id = 'AtlasPersonaliserWordingHelp';
        help.className = 'atlas-personaliser-pilot__field-help';
        wordingWrapper.querySelector('.pplrlabel')?.after(help);
      }
      const supportedLength = Number.parseInt(wording.dataset.maxlength, 10);
      const characterLimit = supportedLength > 0 ? config.characterLimit.replace('{{ count }}', supportedLength) : '';
      help.textContent = [config.wordingGuidance, characterLimit].filter(Boolean).join(' ');
      const descriptions = new Set((wording.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
      descriptions.add(help.id);
      wording.setAttribute('aria-describedby', [...descriptions].join(' '));
      if (supportedLength > 0) wording.maxLength = supportedLength;
    }

    if (addButton && !form.querySelector('.atlas-personaliser-pilot__status')) {
      const status = document.createElement('p');
      status.className = 'atlas-personaliser-pilot__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      addButton.after(status);
    }

    updatePilotChoiceStates(dialog);
  };

  const isSemanticallyRequired = (field) =>
    field.required ||
    field.getAttribute('aria-required') === 'true' ||
    field.classList.contains('cstmfy_c_required');

  const hasRequiredValue = (field, form) => {
    if (field.type === 'checkbox' || field.type === 'radio') {
      if (!field.name) return field.checked;
      return [...form.querySelectorAll(`[name="${CSS.escape(field.name)}"]`)].some((choice) => choice.checked);
    }
    if (field.type === 'file') return Boolean(field.files?.length);
    if (field instanceof HTMLSelectElement && field.multiple) {
      return [...field.selectedOptions].some((option) => String(option.value || '').trim());
    }
    return Boolean(String(field.value || '').trim());
  };

  const getRequiredFields = (form) =>
    [...form.querySelectorAll('input, textarea, select')].filter((field) => {
      if (field.disabled || !isSemanticallyRequired(field)) return false;
      const wrapper = field.closest('.pplr-wrapper');
      return !wrapper || isVisible(wrapper);
    });

  const getValidationTarget = (field) => {
    if (field.type !== 'hidden') return field;
    const wrapper = field.closest('.pplr-wrapper');
    const target = wrapper?.querySelector(
      '.pplr-selecter-selected, .pplr-drop-item, .pplr-swatch-element, [role="button"], [role="radio"]',
    );
    if (target && !target.hasAttribute('tabindex')) target.tabIndex = 0;
    return target || wrapper || field;
  };

  const getFirstIncompleteRequiredField = (form) =>
    getRequiredFields(form).find((field) => !hasRequiredValue(field, form));

  const ensureValidationStatus = (form, addButton) => {
    let status = form.querySelector('.atlas-personaliser-validation__status');
    if (status) return status;
    status = document.createElement('p');
    status.className = 'atlas-personaliser-validation__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    if (addButton) addButton.after(status);
    else form.append(status);
    return status;
  };

  const enhancePersonaliserValidation = (dialog) => {
    dialog.classList.add('atlas-personaliser-validation');
    dialog.querySelectorAll('.pplr_form').forEach((form) => {
      const addButton = form.querySelector('.p_a_t_c');
      if (!addButton) return;
      ensureValidationStatus(form, addButton);
      getRequiredFields(form).forEach((field) => {
        if (!field.id) field.id = `AtlasZeptoRequired-${++validationFieldIndex}`;
        field.setAttribute('aria-required', 'true');
        getValidationTarget(field).setAttribute('aria-required', 'true');
      });
    });
  };

  const ensureEnvolveVisibilityStyles = (host) => {
    const root = host.shadowRoot;
    if (!root) {
      window.setTimeout(scheduleUpdate, 250);
      return;
    }
    if (root.getElementById(envolveStyleId)) return;
    const style = document.createElement('style');
    style.id = envolveStyleId;
    style.textContent = `
      :host([data-atlas-launcher-hidden]) > div.needsclick {
        opacity: 0 !important;
        pointer-events: none !important;
        visibility: hidden !important;
      }
    `;
    root.append(style);
  };

  const setLauncherAccessibility = (hidden) => {
    launcherSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((launcher) => {
        const hiddenForReflow = launcher.matches('envolve-vsa') && window.matchMedia('(max-width: 400px)').matches;
        const hiddenForStickyPurchase = launcher.matches('envolve-vsa') && document.body.classList.contains('atlas-sticky-purchase-active');
        const launcherHidden = hidden || hiddenForReflow || hiddenForStickyPurchase;
        if (launcher.matches('envolve-vsa')) ensureEnvolveVisibilityStyles(launcher);
        launcher.toggleAttribute('inert', launcherHidden);
        launcher.toggleAttribute('data-atlas-launcher-hidden', launcherHidden);
        if (launcherHidden) launcher.setAttribute('aria-hidden', 'true');
        else launcher.removeAttribute('aria-hidden');
      });
    });
    document.querySelectorAll('[id$="__5394799768760407377"] .rq-whatsapp-chat-container > a').forEach((link) => {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Contact us on WhatsApp');
    });
  };

  const enforceUnavailablePurchaseButtons = () => {
    document.querySelectorAll('[data-atlas-unavailable="true"]').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
  };

  const update = () => {
    scheduled = false;
    enforceUnavailablePurchaseButtons();
    const personaliser = getPersonaliser();
    const personaliserOpen = Boolean(personaliser);
    if (personaliserOpen) {
      const dialog = personaliser.querySelector('.pplr-popup, .pplr-modal-box') || personaliser;
      enhancePersonaliserValidation(dialog);
      enhancePilotPersonaliser(dialog);
    }
    if (personaliserOpen && !personaliserWasOpen) {
      personaliserOpener = personaliserOpener || window.atlasPersonaliserOpener || document.activeElement;
      window.atlasPersonaliserOpener = null;
      const dialog = preparePersonaliser(personaliser);
      window.setTimeout(() => {
        const firstControl = [...dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].find(isVisible);
        if (!dialog.contains(document.activeElement)) (firstControl || dialog).focus({ preventScroll: true });
      }, 100);
    }
    if (!personaliserOpen && personaliserWasOpen && personaliserOpener?.isConnected) {
      personaliserOpener.focus({ preventScroll: true });
      personaliserOpener = null;
    }
    personaliserWasOpen = personaliserOpen;

    const bodyStateOpen = bodyStateClasses.some((className) => document.body.classList.contains(className));
    const searchOpen = Boolean(document.querySelector('header-search-dropdown-modal[open="true"], predictive-search[open="true"]'));
    const mediaOpen = Boolean(document.querySelector('product-modal[open]'));
    const genericDialogOpen = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(isUnmanagedDialogOpen);
    const overlayOpen = personaliserOpen || bodyStateOpen || searchOpen || mediaOpen || genericDialogOpen;
    document.body.classList.toggle('atlas-overlay-active', overlayOpen);
    setLauncherAccessibility(overlayOpen);

    if (overlayOpen && launcherSelectors.some((selector) => document.activeElement?.closest?.(selector))) {
      getActiveDialog()?.focus?.({ preventScroll: true });
    }
  };

  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  };

  const showPersonaliserError = (field, message) => {
    const wrapper = field.closest('.pplr-wrapper');
    const target = getValidationTarget(field);
    let error = wrapper?.querySelector(`[data-atlas-validation-for="${CSS.escape(field.id)}"]`);
    if (!error) {
      error = document.createElement('p');
      error.id = `${field.id}-error`;
      error.className = 'atlas-personaliser-validation__error';
      error.dataset.atlasValidationFor = field.id;
      (wrapper || field.parentElement).append(error);
    }
    error.textContent = message;
    target.setAttribute('aria-invalid', 'true');
    const descriptions = new Set((target.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
    descriptions.add(error.id);
    target.setAttribute('aria-describedby', [...descriptions].join(' '));
  };

  const clearPersonaliserError = (field) => {
    if (!field?.id) return;
    const target = getValidationTarget(field);
    target.removeAttribute('aria-invalid');
    const wrapper = field.closest('.pplr-wrapper');
    const error = wrapper?.querySelector(`[data-atlas-validation-for="${CSS.escape(field.id)}"]`);
    if (!error) return;
    const descriptions = (target.getAttribute('aria-describedby') || '')
      .split(' ')
      .filter((id) => id && id !== error.id);
    if (descriptions.length) target.setAttribute('aria-describedby', descriptions.join(' '));
    else target.removeAttribute('aria-describedby');
    error.remove();
  };

  const reportIncompletePersonaliser = (form, field) => {
    const config = getValidationConfig();
    const message = (field.type === 'file' ? config.requiredUploadError : config.requiredError) || field.validationMessage;
    showPersonaliserError(field, message);
    const status = ensureValidationStatus(form, form.querySelector('.p_a_t_c'));
    const summary = config.validationSummary || message;
    if (status.textContent !== summary) status.textContent = summary;
    const target = getValidationTarget(field);
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
      inline: 'nearest',
    });
    window.setTimeout(() => target.focus({ preventScroll: true }), 50);
  };

  const blockIncompletePersonaliser = (event, form) => {
    const missing = getFirstIncompleteRequiredField(form);
    if (!missing) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    reportIncompletePersonaliser(form, missing);
    return true;
  };

  document.addEventListener('keydown', (event) => {
    const predictiveSearch = event.target.closest?.('predictive-search[open="true"]');
    if (event.key === 'Escape' && predictiveSearch) {
      event.preventDefault();
      predictiveSearch.close?.();
      window.setTimeout(scheduleUpdate, 0);
      return;
    }

    const personaliser = getPersonaliser();
    if (!personaliser) return;
    const dialog = personaliser.querySelector('.pplr-popup, .pplr-modal-box') || personaliser;
    if (event.key === 'Escape') {
      const close = personaliser.querySelector('.js-modal-close.pplr_close, .pplr_close');
      if (close) {
        event.preventDefault();
        close.click();
        window.setTimeout(scheduleUpdate, 0);
      }
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(isVisible);
    if (!controls.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!dialog.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('click', (event) => {
    const stickyTrigger = event.target.closest?.('.atlas-sticky-purchase__button');
    if (stickyTrigger) personaliserOpener = stickyTrigger;
    const addButton = event.target.closest?.('.pplr_form .p_a_t_c');
    if (addButton) {
      const form = addButton.closest('.pplr_form');
      if (form && blockIncompletePersonaliser(event, form)) return;
    }
    window.setTimeout(scheduleUpdate, 0);
  }, true);
  document.addEventListener('input', scheduleUpdate, true);
  document.addEventListener('change', scheduleUpdate, true);
  document.addEventListener('change', (event) => {
    const field = event.target.closest?.('.atlas-personaliser-pilot input[type="file"]');
    const file = field?.files?.[0];
    if (!field || !file) return;
    const validType = /\.(jpe?g|png|webp|heic|svg)$/i.test(file.name);
    const validSize = file.size <= 20 * 1024 * 1024;
    if (validType && validSize) return;
    const config = getPilotConfig();
    showPersonaliserError(field, validType ? config.oversizedFile : config.invalidFile);
    field.value = '';
  }, true);
  document.addEventListener('invalid', (event) => {
    const field = event.target.closest?.('.pplr_form input, .pplr_form textarea, .pplr_form select');
    if (!field || !isSemanticallyRequired(field)) return;
    event.preventDefault();
    reportIncompletePersonaliser(field.closest('.pplr_form'), field);
  }, true);
  const clearValidPersonaliserField = (event) => {
    const form = event.target.closest?.('.pplr_form');
    const field = form
      ? getRequiredFields(form).find((candidate) => {
          const target = getValidationTarget(candidate);
          return candidate === event.target || target === event.target || target.contains?.(event.target);
        })
      : null;
    if (!field || !form || !hasRequiredValue(field, form)) return;
    clearPersonaliserError(field);
    if (!getFirstIncompleteRequiredField(form)) {
      const status = form.querySelector('.atlas-personaliser-validation__status');
      if (status) status.textContent = '';
    }
  };
  document.addEventListener('input', clearValidPersonaliserField, true);
  document.addEventListener('change', clearValidPersonaliserField, true);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('.pplr_form');
    if (form) blockIncompletePersonaliser(event, form);
  }, true);
  window.addEventListener('pplrAppInitiated', scheduleUpdate);
  window.addEventListener('pplrAddToCartCompleted', () => {
    const config = getPilotConfig();
    const status = document.querySelector('.atlas-personaliser-pilot__status');
    if (config && status) status.textContent = config.successText;
    scheduleUpdate();
  });
  document.addEventListener('product:modal-open', scheduleUpdate);
  document.addEventListener('product:modal-close', scheduleUpdate);
  document.addEventListener('cart-drawer:open', scheduleUpdate);
  document.addEventListener('cart-drawer:close', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  window.addEventListener('pageshow', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
  document.querySelectorAll('header-search-dropdown-modal, predictive-search, product-modal').forEach((modal) => {
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  });
  scheduleUpdate();
})();
